import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { CONTACT } from "../lib/services";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer
            className="bg-[#1B4332] text-[#FAF9F6] mt-16"
            data-testid="site-footer"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-10 pb-[1cm] grid md:grid-cols-12 gap-10">
                {/* Logo + copyright */}
                <div className="md:col-span-5">
                    <Logo dark size={140} />
                    <p
                        className="mt-5 text-[11px] uppercase tracking-[0.24em] text-[#FAF9F6]/65 leading-relaxed max-w-xs"
                        data-testid="footer-copyright"
                    >
                        © {new Date().getFullYear()} The Food Gala.<br />
                        Crafting Memories &amp; Nourishing Lives. Cuttack · India.
                    </p>
                </div>

                {/* Navigate */}
                <div className="md:col-span-3">
                    <div className="text-[11px] uppercase tracking-[0.3em] text-[#FAF9F6]/60 mb-4">
                        Navigate
                    </div>
                    <ul className="space-y-2.5 text-[15px]">
                        <li><Link className="link-underline" to="/" data-testid="footer-link-home">Home</Link></li>
                        <li><Link className="link-underline" to="/services" data-testid="footer-link-services">Services</Link></li>
                        <li><Link className="link-underline" to="/about" data-testid="footer-link-about">About</Link></li>
                        <li><Link className="link-underline" to="/blog" data-testid="footer-link-blog">Blog</Link></li>
                        <li><Link className="link-underline" to="/enquiry" data-testid="footer-link-enquiry">Enquiry</Link></li>
                        <li><Link className="link-underline text-[#FAF9F6]/60" to="/admin" data-testid="footer-link-admin">Admin</Link></li>
                    </ul>
                </div>

                {/* Contact */}
                <div className="md:col-span-4">
                    <div className="text-[11px] uppercase tracking-[0.3em] text-[#FAF9F6]/60 mb-4">
                        Contact
                    </div>
                    <ul className="space-y-3 text-[15px]">
                        <li className="flex items-start gap-3">
                            <Phone size={16} className="mt-1 shrink-0" />
                            <a href={`tel:${CONTACT.phone}`} data-testid="footer-phone" className="link-underline">{CONTACT.phone}</a>
                        </li>
                        <li className="flex items-start gap-3">
                            <Mail size={16} className="mt-1 shrink-0" />
                            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="link-underline">{CONTACT.email}</a>
                        </li>
                        <li className="flex items-start gap-3">
                            <MapPin size={16} className="mt-1 shrink-0" />
                            <span data-testid="footer-address">{CONTACT.address}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
}
